import { render, staticRenderFns } from "./topTab.vue?vue&type=template&id=0a4b99d0&scoped=true"
import script from "./topTab.vue?vue&type=script&lang=js"
export * from "./topTab.vue?vue&type=script&lang=js"
import style0 from "./topTab.vue?vue&type=style&index=0&id=0a4b99d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b99d0",
  null
  
)

export default component.exports